import{createContext as t,useContext as r}from"react";var o=t({itemWidth:"auto"}),e=function(){return r(o)};export{o as StepperContext,e as useStepperContext};
//# sourceMappingURL=SimpleStepperContext.js.map
